import styled from 'styled-components';

const GlassCard = styled.div`
    background: rgba(255, 255, 255, 0.7);
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
    border-radius: 20px;
    border: 1.5px solid rgba(229, 231, 235, 0.4); /* outlineVariant equivalent approximate */
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.05); /* shadow color approximate */
    padding: 1.5rem;
    width: 100%;
    max-width: 420px; /* Matching mobile constraint */
    position: relative;
    overflow: hidden;


`;

export default GlassCard;
